<template>
    <el-footer>
        <div class="fm-footer">
            <span class="fm-footer-rights">{{ $t('public.footer_rights') }}</span>
            <span class="fm-footer-sep">·</span>
            <span class="fm-footer-address">{{ $t('public.footer_address') }}</span>
            <span class="fm-footer-sep">·</span>
            <a
                class="fm-footer-link"
                :href="termsUrl"
                target="_blank"
                rel="noopener noreferrer">{{ $t('public.footer_terms') }}</a>
            <span class="fm-footer-divider">|</span>
            <a
                class="fm-footer-link"
                :href="privacyUrl"
                target="_blank"
                rel="noopener noreferrer">{{ $t('public.footer_privacy') }}</a>
        </div>
    </el-footer>
</template>
<script>
// 隐私政策 / 使用条款 URL（与登录页注册弹框 registyDia.vue 使用同一地址）
const PRIVACY_URL = 'https://www.vm-iot.com/privacy_policy.html';
const TERMS_URL = 'https://www.vm-iot.com/user_agreement.html';

export default {
    data() {
        return {
            privacyUrl: PRIVACY_URL,
            termsUrl: TERMS_URL
        };
    }
};
</script>
<style scoped lang="scss">
.el-footer {
    position: relative;
    height: 75px !important;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

::v-deep.el-footer {
    font-size: 14px;
    color: rgba(56, 56, 56, 0.5);
    text-align: center;
    line-height: 20px;
}

/* 新版底部栏布局 */
.fm-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px 10px;
    font-size: 12px;
    color: rgba(56, 56, 56, 0.55);
    line-height: 1.6;

    .fm-footer-sep,
    .fm-footer-divider {
        color: rgba(56, 56, 56, 0.3);
    }

    .fm-footer-link {
        color: rgba(56, 56, 56, 0.7);
        text-decoration: none;
        transition: color 0.2s ease;

        &:hover {
            color: #205FE7;
            text-decoration: underline;
        }
    }
}
</style>
